const configTable = [
    {
        prop: "custName",
        label: "顾客姓名",
        cinfigWidth:"120px"
    },
    {
        prop: "cardNo",
        label: "会员卡号",
        cinfigWidth:"120px"
    },
    {
        prop: "levelName",
        label: "顾客等级",
        cinfigWidth:"140px"
    },
    {
        prop: "mobile",
        label: "移动电话",
        cinfigWidth:"120px"
    },
    {
        prop: "serviceOrgCode",
        label: "维护店",
        cinfigWidth:"100px"
    },
    {
        prop: "serviceEmpCode",
        label: "当前维护人",
        cinfigWidth:"100px"
    },
    {
        prop: "serviceEmpName",
        label: "当前维护人姓名",
        cinfigWidth:"120px"
    },
    {
        prop: "custType",
        label: "会员类型",
        cinfigWidth: "150px"
    },
    {
        prop: "saleTagName",
        label: "RMF标签",
        cinfigWidth: "100px"
    }, 
    {
        prop: "lastSaleDate",
        label: "最近购买日",
        cinfigWidth:"150px"
    },
    {
        prop: "currYearAmount",
        label: "今年消费金额",
        cinfigWidth: "150px"
    },
    {
        prop: "prevYearAmount",
        label: "去年消费金额",
        cinfigWidth: "150px"
    },
    {
        prop: "allPoints",
        label: "当前积分",
        cinfigWidth: "150px"
    },
    {
        prop: "lvlAmount",
        label: "保级消费金额",
        cinfigWidth: "150px"
    },
    {
        prop: "lvlSaleTimes",
        label: "保级消费次数",
        cinfigWidth: "150px"
    },
    {
        prop: "state",
        label: "状态",
        cinfigWidth: "150px"
    }
]
export default configTable